import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BackendPlan, networkDescriptions2026 } from '../util/plans';
import { getHeatmapImgSrc, getHeatmapTooltip } from '../util/heatmap';
import { consume } from '@lit/context';
import { breakpointContext } from '../contexts/breakpoint';
import type { BackendFormResponse } from '../util/api';
import { BREAKPOINT } from '../util/breakpoints';
import { inputResponseContext } from '../contexts/inputResponse';
import './comparetooltip';
@customElement('rq-comparemap')
export class Comparemap extends LitElement {
    static styles = css`
        .align-tooltip {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
        }
    `;
    @consume({ context: inputResponseContext, subscribe: true })
    @state()
    inputResponse!: BackendFormResponse;

    @property()
    plan!: BackendPlan;

    @property()
    width?: string;

    @consume({ context: breakpointContext, subscribe: true })
    @state()
    breakpoint!: BREAKPOINT;

    get imgSrc() {
        return getHeatmapImgSrc(this.plan);
    }

    connectedCallback(): void {
        super.connectedCallback();
        if (!this.width) return;
        this.style.setProperty('--rq-heatmap-width', this.width || '100px');
    }

    updated(changedProperties: Map<string, unknown>) {
        if (changedProperties.has('width')) {
            this.style.setProperty('--rq-heatmap-width', this.width || '100px');
        }
    }

    get isMobile() {
        return this.breakpoint === BREAKPOINT.PHONE || this.breakpoint === BREAKPOINT.TABLET;
    }

    render() {
        const networkDescription = networkDescriptions2026[this.plan.lobCode];
        return this.imgSrc
            ? html` <div class="align-tooltip">
                  <rq-comparetooltip
                      hide-line
                      position=${this.isMobile ? 'top' : 'left'}
                      .description=${`<div style="width: 300px;">${getHeatmapTooltip(this.plan)}</div>`}
                  >
                      <div class="heatmap">
                          <lh-image class="img" aria-description=${networkDescription} full-width src=${this.imgSrc}> </lh-image>
                      </div>
                  </rq-comparetooltip>
                  </div>
              </div>`
            : nothing;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'rq-comparemap': Comparemap;
    }
}
